<template>
  <div class="w-full space-y-6">
    <div class="rounded-lg overflow-y-auto">
      <table>
        <thead>
          <th>
            <span class="sr-only"> Posição </span>
          </th>
          <th>
            <span> Usuário </span>
          </th>
          <th colspan="2">
            <span class="sr-only"> Sua posição </span>
          </th>
          <th>
            <span> Bests </span>
          </th>
          <th>
            <span> Resultado </span>
          </th>
        </thead>
        <tbody>
          <template v-if="noData">
            <tr>
              <td class="h-96" colspan="999">
                <div class="flex flex-col gap-4 items-center justify-center">
                  <p class="text-3xl font-bold">Aguardando informações</p>
                  <p class="text-sm text-gray-400 font-normal">O ranking desta semana estará disponível em breve.</p>
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr
              v-for="({ pos, code, bests, result, is_user }, index) in top_10.slice(3, 10)"
              :key="`${pos}_${index}`"
              :class="{ 'bg-ontick-blue-600 bg-opacity-10': is_user }"
            >
              <td class="!text-right">
                <span> {{ index + 4 }}º </span>
              </td>
              <td class="font-medium text-ontick-blue-600">
                <span v-if="code">{{ code }}</span>
                <span v-else class="font-normal text-gray-500"> - </span>
              </td>
              <td colspan="2" class="font-normal">
                <span v-if="is_user"> Sua posição! </span>
              </td>
              <td>
                <span v-if="bests">{{ bests }}</span>
                <span v-else class="font-normal text-gray-500"> - </span>
              </td>
              <td>
                <div class="flex items-center gap-2">
                  <PnlIndicatorComponent :pnl="result" v-if="result" />
                  <span v-if="result">
                    {{ result | currency }}
                  </span>
                  <span v-else class="font-normal text-gray-500"> - </span>
                </div>
              </td>
            </tr>
            <template v-if="showBottomTable">
              <tr>
                <td colspan="999" class="!bg-ontick-graphite-600">
                  <div class="flex items-center justify-center w-full">
                    <i v-html="$icons.kebab" class="rotate-90 scale-125 text-ontick-carbon-400"></i>
                  </div>
                </td>
              </tr>
              <tr
                v-for="({ pos, code, bests, result, is_user }, index) in user_data"
                :key="'user_pos_' + pos"
                :class="{ 'bg-ontick-blue-600 bg-opacity-10': is_user }"
              >
                <td class="!text-right">
                  <span> {{ pos }}º </span>
                </td>
                <td class="font-medium text-ontick-blue-600">
                  <span>{{ code }}</span>
                </td>
                <td colspan="2" class="font-normal">
                  <span v-if="is_user"> Sua posição! </span>
                </td>
                <td>
                  <span>{{ bests }}</span>
                </td>
                <td>
                  <div class="flex items-center gap-2">
                    <PnlIndicatorComponent :pnl="result" v-if="result" />
                    <span>
                      {{ result | currency }}
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
    <div class="flex items-center justify-between" v-if="!user_data">
      <p class="text-sm font-normal text-gray-50">
        Faça seu primeiro <strong class="uupercase">Best</strong> <br />
        e entre para a competição!
      </p>
      <router-link
        to="/bests"
        class="h-14 bg-ontick-blue-900 flex items-center justify-center rounded-full shadow-lg font-semibold px-6 hover:brightness-125 active:brightness-75 transition-all"
      >
        <span> Ver Disponíveis </span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PnlIndicatorComponent from "./pnl-indicator.component.vue";
export default {
  components: {
    PnlIndicatorComponent,
  },

  props: {
    top_10: {
      type: Array,
    },
    user_data: {
      type: Array,
    },
  },

  computed: {
    ...mapGetters({ getUserBests: "bests/getUserBests" }),
    showBottomTable() {
      if (!this.user_data) return false;

      let user_index = this.user_data.map((item) => item.is_user).findIndex((item) => item == true);
      if (user_index == -1) return false;
      if (this.user_data[user_index].pos <= 3) return false;
      if (this.user_data[user_index].pos >= 4 && this.user_data[user_index].pos <= 10) return false;

      return true;
    },
    noData() {
      return this.top_10.length == 0;
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  @apply text-sm w-full text-left;
  thead {
    @apply bg-ontick-steel-500;
    th {
      @apply p-2;
    }
  }
  tbody {
    @apply bg-ontick-graphite-500 font-bold;
    tr {
      td {
        @apply p-2;
      }
    }
  }
}
</style>
